import { render, staticRenderFns } from "./ShipmentCertificateMobile.vue?vue&type=template&id=7f0675ad&scoped=true&"
import script from "./ShipmentCertificateMobile.vue?vue&type=script&lang=ts&"
export * from "./ShipmentCertificateMobile.vue?vue&type=script&lang=ts&"
import style0 from "./ShipmentCertificateMobile.vue?vue&type=style&index=0&id=7f0675ad&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f0675ad",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VChip,VDataTable,VDialog,VIcon,VSelect,VTextField})
